import React from 'react';

export default function NFTCard({ nft, onClick }) {
  return (
    <div className="nft-card" onClick={onClick}>
      <div className="nft-img-wrap">
        <img src={nft.gif} alt={nft.name} />
        <span className={`nft-rarity rarity-${nft.rarity}`}>{nft.rarity}</span>
        <span className="nft-value-badge">${nft.value}</span>
      </div>
      <div className="nft-body">
        <div className="nft-name">{nft.name}</div>
        <div className="nft-id">#{nft.id}</div>
      </div>
    </div>
  );
}
